/**
 * Services section component
 */

import { Card } from '../ui/Card';
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';
import { motion } from 'framer-motion';
import servicesData from "@/data/services.json";
const services = servicesData.items;
const sectionTitle = servicesData.section_title;
const sectionTitleParts = servicesData.section_title_parts || [{ text: sectionTitle, highlight: false }];
const sectionSubtitle = servicesData.section_subtitle;

export function Services() {
  const { ref, isIntersecting } = useIntersectionObserver({ threshold: 0.1 });

  return (
    <section id="services" ref={ref} className="section" style={{ backgroundColor: 'var(--color-gray-50)' }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isIntersecting ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="has-text-centered mb-6"
        >
          <h2 className="title is-2 has-text-weight-bold">
            {sectionTitleParts.map((part, index) => (
              part.highlight ? (
                <span key={index} className="gradient-text">{part.text}</span>
              ) : (
                <span key={index}>{part.text}</span>
              )
            ))}
          </h2>
          <p className="subtitle is-5" style={{ maxWidth: '800px', margin: '0 auto' }}>
            {sectionSubtitle}
          </p>
        </motion.div>

        <div className="grid-3">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, y: 30 }}
              animate={isIntersecting ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <Card style={{ height: '100%', padding: '2rem', textAlign: 'center' }}>
                <div className="service-icon">
                  <i className={`fas ${service.icon}`}></i>
                </div>
                <h3 className="service-title">
                  {service.title}
                </h3>
                <p className="service-description">{service.description}</p>
                <ul style={{ color: 'var(--color-gray-600)', listStyle: 'none', padding: 0, textAlign: 'left' }}>
                  {service.features.map((feature, idx) => (
                    <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                      <i className="fas fa-check" style={{ color: 'var(--color-lime-500)' }}></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
